import { Component, Inject, ViewChild, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JoiEvent } from 'src/app/store/events.era';
import { DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component';
import { removeFromListByIndex, removeOrAddToListByElement } from '../../helpers/helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { Ranking } from 'globals/store/events.data';
import { CdkDrag, CdkDragDrop,  CdkDropList,  moveItemInArray } from '@angular/cdk/drag-drop'
import { Wrapper } from 'src/app/components/wrapper.component';
import { titleCase } from './../../helpers/helpers';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { createId, jsonCopyObject } from 'globals/helpers/helpers';
import { DialogPositionNumbers } from 'globals/store/dialog.selector.data';


@Component({
    selector: 'rank-select-dialog',
    template: `
<dialog-wrapper
  [dialogTitle]="mode === 'new' ? (data.isCategory ? 'New ' + capitalType + ' Category' : 'New ' + capitalType) 
    : mode === 'edit' ? (data.isCategory ? 'Edit ' + capitalType + ' Category' : 'Edit ' + capitalType) 
    : (data.isCategory ? capitalType + ' Categories' : capitalType + 's')"
  [titleHeight]="40"
  [hideBottom]="mode === 'select'"
  [showClose]="mode === 'select'"
  [smallTitle]="true"
  [tiny]="true"
  [giveMeTwenty]="true"
  [showBack]="mode !== 'select'"
  [successLabel]="'SAVE'"
  [deleteLeft]="mode === 'edit' && !editingType.cannotDelete"
  [disabled]="mode !== 'select' && !editingType.name"
  (close)="close()"
  (submit)="mode === 'new' ? addNewType() : updateType()"
  (back)="selectMode()"
  (delete)="deleteType($event)"
>
  <ng-container *ngIf="mode !== 'select'">
    <mutating-input [object]="editingType" prop="name" [focus]="true" [placeholder]="data.isCategory ? capitalType + ' Category' : capitalType"></mutating-input>
  </ng-container>
  <div class="message" *ngIf="mode === 'select' && !!data.message">{{ data.message }}</div>
  <add-manage-wrapper 
    *ngIf="mode === 'select'"
    [readOnly]="!event || !!event.is_readonly"
    [openLabel]="'+ CREATE A NEW ' + (data.isCategory ? capitalType + ' CATEGORY' : capitalType) | uppercase" 
    [hideHRule]="true"
    (open)="editNewType()" 
    cdkDropList
    [cdkDropListData]="data.ranks"
    (cdkDropListDropped)="dropLevel($event)"
    >
    <div class="empty-text" *ngIf="!data.ranks.length">No {{ data.isCategory ? lowerCaseType + ' categories' : lowerCaseType + 's' }} in this event</div>
    <div 
      class="sponsor-type" 
      [ngClass]="{ noSelect: data.noSelect }"
      *ngFor="let level of data.ranks"
      cdkDrag
      >
      <div class="label" (click)="select(level)" [ngClass]="{ selected: data.selectedRankId === level.id || data.selectedIds?.includes(level.id) }">
        <icon class="handle" cdkDragHandle matIcon="drag_indicator"></icon>
        <div class="name">{{ level.name }}</div>
        <div style="flex:1"></div>
        <icon class="check" [ngClass]="{selected: true, invisible: data.selectedRankId !== level.id}" icon="tick_24px"></icon>
      </div> 
      <icon *ngIf="event && !event.is_readonly" class="edit" (click)="editOldType(level)" matIcon="edit"></icon>
    </div>
  </add-manage-wrapper>

</dialog-wrapper>
  `,
    styleUrls: ['rank-select.scss'],
    standalone: true,
    imports: [DialogWrapperComponent, CdkDrag, CdkDropList, IconComponent, CommonModule, MutatingInputComponent, AddManageWrapperComponent],
})
export class RankSelectDialogComponent extends Wrapper<RankSelectDialogComponent> implements OnInit {
  value: string
  mode: 'select' | 'edit' | 'new' = 'select'
  editingType: Ranking
  capitalType: string
  lowerCaseType: string
  event: JoiEvent
  @ViewChild(DialogWrapperComponent, { static: true }) dialogWrapper: DialogWrapperComponent
  
  constructor(public dialogRef: MatDialogRef<RankSelectDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: RankingDialogData) {
    super()
    this.subProp(this.store.select('events', 'event'), 'event')    
    this.dialogRef.backdropClick().subscribe(() => {
      this.dialogRef.close(this.data);
    });
  }

  ngOnInit() {
    this.initializePosition()
    const fullType = (this.data.cueName ? this.data.cueName + ' ' : '') + this.data.type
    this.capitalType = titleCase(fullType)
    this.lowerCaseType = fullType.toLowerCase()
  }

  selectMode() {
    this.mode = 'select'
    this.dialogWrapper.fitChildrenWithDelay(200)
  }

  editNewType() {
    this.editingType = { id: `${this.data.cueKey || ''}${createId()}`, name: '', rank: this.data.ranks.length }
    this.mode = 'new'
    this.dialogWrapper.fitChildrenWithDelay(200)
  }

  editOldType(type: Ranking) {
    this.editingType = jsonCopyObject(type)
    this.mode = 'edit'
    this.dialogWrapper.fitChildrenWithDelay(200)
  }

  updateType() {
    const typeIndex = this.data.ranks.findIndex(l => l.id === this.editingType.id)
    const ranks = jsonCopyObject(this.data.ranks)
    ranks[typeIndex] = this.editingType
    this.data = {...this.data, ranks}
    this.mode = 'select'
    this.editingType = null
    this.dialogWrapper.fitChildrenWithDelay(200)
  }

  async deleteType(event) {
    const data: ConfirmDeleteData = {
      title: `Delete ${this.lowerCaseType} in this event`,
      para: `All references to this ${this.lowerCaseType} will be deleted in this ${ this.data.deleteLocation || 'event'}`,
      deleteButtonText: 'DELETE',
      dialog: this.dialog,
      rect: event.target.getBoundingClientRect()
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    removeFromListByIndex(this.data.ranks, this.data.ranks.findIndex(l => l.id === this.editingType.id))
    this.mode = 'select'
    this.editingType = null
    this.dialogWrapper.fitChildrenWithDelay(300)
  }

  addNewType() {
    const ranks = jsonCopyObject(this.data.ranks)
    ranks.push(this.editingType)
    this.data = {...this.data, ranks}
    this.mode = 'select'
    this.editingType = null
    this.dialogWrapper.fitChildrenWithDelay(300)
  }

  private initializePosition() {
    if (this.data.position) {
      const { top, left, bottom } = this.data.position
      console.log({ top, bottom, left })
      if (top) {
        this.dialogRef.updatePosition({ top: top + 10 + 'px', left: left + 'px' })
      } else if (bottom) {
        this.dialogRef.updatePosition({ bottom: bottom + 'px', left: left + 'px' })
      }      
    }
    window['updatePosition'] = this.dialogRef.updatePosition.bind(this.dialogRef)
  }

  select(level: Ranking) {
    if (this.data.noSelect) return

    if (this.data.selectedIds !== undefined) {
      removeOrAddToListByElement(this.data.selectedIds, level.id)      
    } else {
      if (level.id === this.data.selectedRankId) this.data.selectedRankId = null
      else this.data.selectedRankId = level.id
      this.close();
    }
  }

  dropLevel(event: CdkDragDrop<Ranking[]>) {
    moveItemInArray(this.data.ranks, event.previousIndex, event.currentIndex);
  }

  close() {
    const { ranks, selectedIds, selectedRankId } = this.data
    this.dialogRef.close(this.data) // selectedIds will at least be an empty array for multiselect
  }

}

export interface RankingDialogData {
  ranks: Ranking[]
  cueName?: string
  cueKey?: string
  message?: string
  deleteLocation?: string 
  type: string
  selectedRankId?: string
  selectedIds?: string[] // if using multiselect must pass in at least an empty array
  position: DialogPositionNumbers
  noSelect?: boolean
  isCategory?: boolean
}
